import { fromJS } from 'immutable';
import { fetchingState } from '@constants';
import { SUCCESS, START, ERROR } from '../actions/global';
import * as actions from '../actions/massCassValidation';

const initialState = fromJS({
  createNewDialogueIsVisible: false,
  selectedRunId: undefined,
  massCassValidationJobs: {
    data: {
      records: [],
      totalRecords: 0,
    },
    state: null,
    pagination: {
      totalRecords: 0,
      page: 1,
      pageSize: 50,
      rowsPerPageOptions: [50, 100, 150, 1000],
    },
  },
  massCassValidationJobDetails: {
    data: {
      records: [],
      totalRecords: 0,
    },
    state: null,
    displayType: 'all',
    pagination: {
      totalRecords: 0,
      page: 1,
      rowsPerPage: 40,
      rowsPerPageOptions: [40, 80, 120, 1000],
    },
  },
});

const MassCassValidationReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.SET_MASS_CASS_VALIDATION_CREATE_NEW_DIALOGUE_IS_VISIBLE: {
      return state.set('createNewDialogueIsVisible', action.payload);
    }

    case actions.FETCH_MASS_CASS_VALIDATION_JOBS[START]:
      return state.setIn(
        ['massCassValidationJobs', 'state'],
        fetchingState.FETCHING,
      );

    case actions.FETCH_MASS_CASS_VALIDATION_JOBS[SUCCESS]:
      return state
        .setIn(['massCassValidationJobs', 'state'], fetchingState.LOADED)
        .setIn(
          ['massCassValidationJobs', 'data', 'records'],
          fromJS(action.data ? action.data.results.records : []),
        )
        .setIn(
          ['massCassValidationJobs', 'data', 'totalRecords'],
          fromJS(action.data ? action.data.results.totalRecords : []),
        )
        .setIn(
          ['massCassValidationJobs', 'pagination', 'totalRecords'],
          action.data ? action.data.totalRecords : 0,
        );

    case actions.FETCH_MASS_CASS_VALIDATION_JOBS[ERROR]: {
      return state.setIn(
        ['massCassValidationJobs', 'state'],
        fetchingState.ERROR,
      );
    }

    case actions.FETCH_MASS_CASS_VALIDATION_JOB_DETAILS[START]:
      return state.setIn(
        ['massCassValidationJobs', 'state'],
        fetchingState.FETCHING,
      );

    case actions.FETCH_MASS_CASS_VALIDATION_JOB_DETAILS[SUCCESS]:
      return state
        .setIn(['massCassValidationJobDetails', 'state'], fetchingState.LOADED)
        .setIn(
          ['massCassValidationJobDetails', 'data'],
          fromJS(action.data ? action.data.results : []),
        )
        .setIn(
          ['massCassValidationJobDetails', 'pagination', 'totalRecords'],
          action.data ? action.data.totalRecords : 0,
        );

    case actions.FETCH_MASS_CASS_VALIDATION_JOB_DETAILS[ERROR]: {
      return state.setIn(
        ['massCassValidationJobDetails', 'state'],
        fetchingState.ERROR,
      );
    }

    // Update job if there is a change in the runStatus
    case actions.CONVERT_MASS_CASS_VALIDATION_ADDRESSES[SUCCESS]:
      return state.updateIn(
        ['massCassValidationJobs', 'data', 'records'],
        (records) =>
          records.map((record) =>
            record.get('runID') === action.data.results.runID &&
            record.get('runStatus') !== action.data.results.runStatus
              ? fromJS(action.data.results)
              : record,
          ),
      );

    case actions.ADD_MASS_CASS_VALIDATION_JOB: {
      return state.updateIn(
        ['massCassValidationJobs', 'data', 'records'],
        (arr) =>
          arr.some((job) => job?.get('runID') === action.payload.runID)
            ? arr // If exists, return array unchanged
            : arr.unshift(fromJS(action.payload)), // If not, add to the beginning
      );
    }

    // Update job if there is a change in the runStatus
    case actions.UPDATE_MASS_CASS_VALIDATION_JOB: {
      return state.updateIn(
        ['massCassValidationJobs', 'data', 'records'],
        (records) =>
          records.map((record) =>
            record.get('runID') === action.payload.runID &&
            record.get('runStatus') !== action.payload.runStatus
              ? fromJS(action.payload)
              : record,
          ),
      );
    }

    case actions.SET_MASS_CASS_VALIDATION_JOBS_TABLE_PAGE_SIZE: {
      return state.setIn(
        ['massCassValidationJobs', 'pagination', 'pageSize'],
        action.payload,
      );
    }

    default: {
      return state;
    }
  }
};

export default MassCassValidationReducer;
